import PromotionsCard from './PromotionsCard';
import { ILineItem } from '../../../../contexts/CartContext/CartContext.types';
import { useEffect, useState } from 'react';
import usePromotionsCardStyles from './PromotionsCard.styles';

const PromotionsSection = (item: ILineItem) => {
    const styles = usePromotionsCardStyles();

    const [hasTradeIn, setHasTradeIn] = useState((item.device?.tradeIn?.price ?? 0) > 0);

    const [tradeInMonthly, setTradeInMonthly] = useState(item.device?.tradeIn?.pricePerMonth ?? 0);
    const [tradeInToday, setTradeInToday] = useState(item.device?.tradeIn?.price ?? 0);

    const [show, setShow] = useState(false);

    useEffect(() => {
        setHasTradeIn((item.device?.tradeIn?.price ?? 0) > 0);

        // NOTE: Viaero has asked that the trade-in value be calculated as a flat amount
        // instead of monthly. Removed previous logic listed below, which is being kept here
        // in case Viaero wants it changed back.
        // if (item.device?.usePricingOptions) {
        //     setTradeInMonthly(item.device?.tradeIn?.pricePerMonth ?? 0);
        //     setTradeInToday(0);
        // } else {
        setTradeInToday(item.device?.tradeIn?.price ?? 0);
        setTradeInMonthly(0);
        // }

        setShow(item.promoSummary?.hasPromo ?? item.promoSummary?.hasBundleDiscount ?? hasTradeIn);
    }, [item]);

    if (show) {
        return (
            <div className={styles.promoSectionRoot}>
                <div className={styles.title}>Promotions</div>

                {hasTradeIn && (
                    <PromotionsCard
                        title={'Trade-in'}
                        subTitle={`${item.device?.tradeIn?.device_make} ${item.device?.tradeIn?.device_model}`}
                        description={`$${item.device?.tradeIn?.price} estimated trade-in value. Mail within 30 days. Credit will be issued on your billing after reviewing phone.`}
                        dueMonthly={tradeInMonthly > 0 ? `-$${tradeInMonthly.toFixed(2)}` : ''}
                        dueToday={tradeInToday > 0 ? `-$${tradeInToday.toFixed(2)}` : ''}
                        valueSubText={
                            tradeInMonthly > 0
                                ? `for ${item.device?.product.pricing.numMonths.toString()}mos`
                                : ''
                        }
                    />
                )}

                {item.promoSummary?.hasPromo && (
                    <PromotionsCard
                        title={item.promoSummary.promoResponse.promo.dealInfo.title}
                        dueMonthly={
                            item.promoSummary.dueMonthly > 0
                                ? `-$${item.promoSummary.dueMonthly.toFixed(2)}`
                                : ''
                        }
                        dueToday={
                            item.promoSummary.dueToday
                                ? `-$${item.promoSummary.dueToday.toFixed(2)}`
                                : ''
                        }
                        valueSubText={
                            item.promoSummary.dueMonthly > 0
                                ? `for ${item.device?.product.pricing.numMonths.toString()}mos`
                                : ''
                        }
                    />
                )}

                {item.promoSummary?.hasBundleDiscount && (
                    <PromotionsCard
                        title={item.promoSummary?.bundleDiscountPromo?.dealInfo.title ?? ''}
                        dueMonthly={`-$${item.promoSummary?.bundleDiscount.toFixed(2)}`}
                        valueSubText={`for ${item.device?.product.pricing.numMonths.toString()}mos`}
                        dueToday={''}
                    />
                )}
            </div>
        );
    }
};

export default PromotionsSection;
